import React from "react";

const RightIcon = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="203"
        height="167"
        viewBox="0 0 203 167"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M195.468 28.4195L67.0664 2.658L43.9699 117.777L172.372 143.538L195.468 28.4195Z"
            fill="#556080"
          />
          <path
            d="M174.141 146.196L41.312 119.546L65.2969 0L198.126 26.6498L174.141 146.196ZM46.628 116.007L170.602 140.88L192.81 30.1892L68.8362 5.31597L46.628 116.007Z"
            fill="#3E465B"
          />
          <path
            d="M97.7093 108.65C89.7993 107.063 88.139 98.5336 87.5139 95.3245L87.4526 95.0105C85.338 84.2922 85.9149 73.5426 86.4721 63.1438L86.6831 59.0616C87.3494 45.4099 95.9014 34.7175 107.478 33.056C109.82 32.72 112.356 32.8212 115.013 33.3542C119.237 34.2016 123.174 35.9957 126.273 37.5868L126.304 37.5793C130.116 36.8311 134.099 36.8335 137.832 37.5824C142.716 38.5622 147.044 40.7731 150.352 43.9816C155.063 48.5424 157.844 54.07 158.175 59.5368C158.867 70.9487 153.879 81.7021 149.477 91.1913C148.783 92.6871 148.106 94.1472 147.475 95.5704L146.91 96.8481C145.096 100.975 143.04 105.654 139.411 109.818C134.883 115.021 130.149 114.985 127.729 114.5C118.896 112.728 117.698 102.456 117.185 98.0672C117.053 96.926 116.978 95.7273 116.909 94.509C116.876 93.913 116.832 93.1486 116.765 92.4144C115.695 93.7081 114.727 95.3747 113.64 97.2476C112.946 98.4419 112.248 99.6376 111.498 100.807C110.125 102.954 107.266 107.414 101.301 108.64L99.5047 109.01L97.7093 108.65Z"
            fill="#7383BF"
          />
          <path
            d="M149.161 60.082C149.815 70.8575 143.502 82.2846 139.224 91.8978C137.365 96.0778 135.645 100.392 132.605 103.885C127.79 109.414 126.587 100.693 126.159 97.0212C125.634 92.5082 126.283 86.9432 122.556 83.5724C118.843 80.2136 114.416 81.9968 111.255 85.0796C108.053 88.2048 106.271 92.2227 103.893 95.9348C102.793 97.6509 101.62 99.3546 99.4826 99.7939C97.3927 99.3746 96.7066 95.2644 96.3106 93.2551C94.1497 82.2971 95.1633 70.5759 95.7028 59.4964C96.0826 51.7035 100.34 43.2009 108.758 41.9949C113.331 41.3396 118.9 43.9078 122.925 46.0256C125.237 47.2426 124.831 46.9146 127.449 46.558C127.651 46.5293 127.852 46.4798 128.06 46.4388C133.733 45.3224 140.05 46.5736 144.065 50.4627C146.776 53.0885 148.942 56.5008 149.161 60.082Z"
            fill="#9EF5FC"
          />
          <path
            d="M99.4904 102.098L99.041 102.008C95.5808 101.314 94.6922 96.7555 94.1634 94.0309L94.0976 93.693C92.1495 83.8095 92.7026 73.4881 93.2361 63.506L93.4476 59.387C93.8762 50.6275 98.6795 41.1612 108.439 39.7616C113.618 39.0159 119.462 41.6485 123.978 44.0283C124.292 44.195 125.038 44.5842 125.234 44.6326C125.355 44.6247 125.546 44.5779 125.824 44.5276C126.169 44.468 126.594 44.3943 127.143 44.3203L127.624 44.2209C134.424 42.8815 141.32 44.6543 145.638 48.8416C149.135 52.226 151.188 56.1683 151.416 59.9426C152.007 69.6482 147.401 79.5778 143.338 88.3383C142.628 89.8678 141.934 91.3614 141.288 92.8139L140.713 94.1195C139.015 97.9816 137.259 101.98 134.307 105.364C132.431 107.521 130.566 108.331 128.685 107.755C125.454 106.755 124.485 102.129 123.92 97.2767C123.801 96.2626 123.739 95.1976 123.677 94.1144C123.474 90.5917 123.285 87.2673 121.047 85.2432C118.011 82.4901 114.598 84.9718 112.837 86.6911C110.769 88.7082 109.322 91.2021 107.791 93.8404C107.145 94.9497 106.5 96.0617 105.803 97.1493C104.733 98.8207 103.111 101.351 99.9475 102.001L99.4904 102.098ZM112.785 44.4196C111.488 44.1593 110.229 44.0655 109.081 44.2313C101.867 45.2667 98.2965 52.7003 97.9607 59.6085L97.7456 63.7452C97.226 73.4515 96.6907 83.4885 98.529 92.8181L98.5992 93.1684C99.0057 95.2627 99.4056 96.6441 99.7914 97.2926C100.602 96.8197 101.243 95.8982 101.996 94.7181C102.657 93.6854 103.269 92.6292 103.881 91.5774C105.5 88.7909 107.173 85.9118 109.682 83.465C114.466 78.7988 119.982 78.199 124.074 81.8986C127.686 85.1657 127.949 89.7854 128.184 93.8625C128.24 94.8549 128.296 95.8309 128.404 96.76C128.927 101.245 129.619 102.782 129.966 103.289C130.161 103.155 130.476 102.894 130.902 102.401C133.4 99.5333 134.943 96.0223 136.578 92.304L137.163 90.9799C137.818 89.5062 138.521 87.9891 139.242 86.441C143.078 78.1648 147.429 68.7828 146.909 60.2175C146.749 57.5716 145.184 54.6852 142.498 52.0851C139.229 48.9143 133.861 47.6047 128.501 48.6527C128.147 48.7291 127.947 48.772 127.747 48.7962C127.278 48.861 126.905 48.9268 126.602 48.9788C124.703 49.3093 124.081 49.1823 121.879 48.0243C119.319 46.6793 115.94 45.0525 112.785 44.4196Z"
            fill="#6ED0FF"
          />
          <path
            d="M80.7726 37.649L71.9173 35.8723C70.693 35.6267 69.902 34.4386 70.1476 33.2144C70.3933 31.9901 71.5814 31.1991 72.8056 31.4447L81.6609 33.2214C82.8852 33.467 83.6762 34.6551 83.4306 35.8793C83.1849 37.1036 81.9968 37.8946 80.7726 37.649Z"
            fill="#7383BF"
          />
          <path
            d="M91.4042 30.5704L73.6937 27.0171C72.4694 26.7715 71.6784 25.5833 71.924 24.3591C72.1696 23.1348 73.3577 22.3438 74.582 22.5894L92.2926 26.1427C93.5168 26.3884 94.3078 27.5765 94.0622 28.8007C93.8166 30.025 92.6285 30.816 91.4042 30.5704Z"
            fill="#7383BF"
          />
          <path
            d="M84.3258 19.9384L75.4705 18.1617C74.2463 17.9161 73.4552 16.728 73.7009 15.5038C73.9465 14.2795 75.1346 13.4885 76.3588 13.7341L85.2141 15.5108C86.4384 15.7564 87.2294 16.9445 86.9838 18.1687C86.7382 19.393 85.55 20.184 84.3258 19.9384Z"
            fill="#7383BF"
          />
          <path
            d="M106.908 22.1663C108.131 22.4116 109.321 21.6193 109.566 20.3966C109.811 19.174 109.019 17.9839 107.796 17.7386C106.574 17.4933 105.384 18.2856 105.138 19.5083C104.893 20.731 105.685 21.921 106.908 22.1663Z"
            fill="#7383BF"
          />
          <path
            d="M120.191 24.8313C121.413 25.0766 122.603 24.2843 122.849 23.0616C123.094 21.8389 122.302 20.6489 121.079 20.4036C119.856 20.1583 118.666 20.9506 118.421 22.1733C118.176 23.3959 118.968 24.5859 120.191 24.8313Z"
            fill="#7383BF"
          />
          <path
            d="M133.474 27.4963C134.697 27.7416 135.887 26.9493 136.132 25.7266C136.377 24.504 135.585 23.314 134.362 23.0686C133.14 22.8233 131.95 23.6156 131.704 24.8383C131.459 26.061 132.251 27.251 133.474 27.4963Z"
            fill="#7383BF"
          />
          <path
            d="M146.757 30.1613C147.979 30.4066 149.169 29.6143 149.415 28.3916C149.66 27.1689 148.868 25.9789 147.645 25.7336C146.422 25.4883 145.232 26.2806 144.987 27.5033C144.742 28.7259 145.534 29.9159 146.757 30.1613Z"
            fill="#7383BF"
          />
          <path
            d="M160.04 32.8262C161.263 33.0715 162.453 32.2792 162.698 31.0566C162.943 29.8339 162.151 28.6439 160.928 28.3986C159.706 28.1533 158.515 28.9456 158.27 30.1682C158.025 31.3909 158.817 32.5809 160.04 32.8262Z"
            fill="#7383BF"
          />
          <path
            d="M173.323 35.4912C174.545 35.7365 175.735 34.9442 175.981 33.7215C176.226 32.4989 175.434 31.3089 174.211 31.0635C172.988 30.8182 171.798 31.6105 171.553 32.8332C171.308 34.0559 172.1 35.2459 173.323 35.4912Z"
            fill="#7383BF"
          />
          <path
            d="M186.606 38.1562C187.828 38.4015 189.018 37.6092 189.264 36.3866C189.509 35.1639 188.717 33.9739 187.494 33.7286C186.271 33.4833 185.081 34.2756 184.836 35.4982C184.591 36.7209 185.383 37.9109 186.606 38.1562Z"
            fill="#7383BF"
          />
          <path
            d="M112.217 30.1403C113.44 30.3856 114.63 29.5933 114.875 28.3706C115.12 27.148 114.328 25.9579 113.105 25.7126C111.883 25.4673 110.693 26.2596 110.447 27.4823C110.202 28.7049 110.994 29.895 112.217 30.1403Z"
            fill="#7383BF"
          />
          <path
            d="M125.5 32.8053C126.722 33.0506 127.912 32.2583 128.158 31.0356C128.403 29.8129 127.611 28.6229 126.388 28.3776C125.165 28.1323 123.975 28.9246 123.73 30.1473C123.485 31.3699 124.277 32.5599 125.5 32.8053Z"
            fill="#7383BF"
          />
          <path
            d="M138.783 35.4702C140.005 35.7155 141.195 34.9232 141.441 33.7006C141.686 32.4779 140.894 31.2879 139.671 31.0426C138.448 30.7973 137.258 31.5896 137.013 32.8122C136.768 34.0349 137.56 35.2249 138.783 35.4702Z"
            fill="#7383BF"
          />
          <path
            d="M152.066 38.1352C153.288 38.3805 154.478 37.5882 154.724 36.3656C154.969 35.1429 154.177 33.9529 152.954 33.7076C151.731 33.4623 150.541 34.2546 150.296 35.4773C150.051 36.6999 150.843 37.8899 152.066 38.1352Z"
            fill="#7383BF"
          />
          <path
            d="M165.348 40.8002C166.571 41.0455 167.761 40.2532 168.006 39.0306C168.252 37.8079 167.459 36.6179 166.237 36.3726C165.014 36.1273 163.824 36.9196 163.579 38.1422C163.333 39.3649 164.126 40.5549 165.348 40.8002Z"
            fill="#7383BF"
          />
          <path
            d="M178.632 43.4652C179.854 43.7105 181.044 42.9182 181.29 41.6955C181.535 40.4729 180.743 39.2828 179.52 39.0375C178.297 38.7922 177.107 39.5845 176.862 40.8072C176.617 42.0299 177.409 43.2199 178.632 43.4652Z"
            fill="#7383BF"
          />
          <path
            d="M157.374 46.1092C158.597 46.3545 159.787 45.5622 160.032 44.3395C160.278 43.1168 159.485 41.9268 158.263 41.6815C157.04 41.4362 155.85 42.2285 155.605 43.4512C155.359 44.6738 156.152 45.8639 157.374 46.1092Z"
            fill="#7383BF"
          />
          <path
            d="M162.684 54.0831C163.907 54.3284 165.097 53.5361 165.342 52.3135C165.587 51.0908 164.795 49.9008 163.572 49.6555C162.35 49.4102 161.16 50.2025 160.914 51.4252C160.669 52.6478 161.461 53.8378 162.684 54.0831Z"
            fill="#7383BF"
          />
          <path
            d="M170.658 48.7741C171.88 49.0194 173.07 48.2271 173.316 47.0045C173.561 45.7818 172.769 44.5918 171.546 44.3465C170.323 44.1012 169.133 44.8935 168.888 46.1162C168.643 47.3388 169.435 48.5288 170.658 48.7741Z"
            fill="#7383BF"
          />
          <path
            d="M167.993 62.0571C169.216 62.3024 170.406 61.5101 170.651 60.2874C170.896 59.0647 170.104 57.8747 168.881 57.6294C167.659 57.3841 166.469 58.1764 166.223 59.3991C165.978 60.6217 166.77 61.8118 167.993 62.0571Z"
            fill="#7383BF"
          />
          <path
            d="M175.967 56.7481C177.189 56.9934 178.379 56.2011 178.625 54.9785C178.87 53.7558 178.078 52.5658 176.855 52.3205C175.632 52.0752 174.442 52.8675 174.197 54.0901C173.952 55.3128 174.744 56.5028 175.967 56.7481Z"
            fill="#7383BF"
          />
          <path
            d="M183.94 51.4392C185.163 51.6845 186.353 50.8922 186.598 49.6695C186.844 48.4468 186.051 47.2568 184.829 47.0115C183.606 46.7662 182.416 47.5585 182.171 48.7812C181.925 50.0038 182.718 51.1939 183.94 51.4392Z"
            fill="#7383BF"
          />
          <path
            d="M181.276 64.7221C182.498 64.9674 183.688 64.1751 183.934 62.9524C184.179 61.7298 183.387 60.5398 182.164 60.2944C180.941 60.0491 179.751 60.8414 179.506 62.0641C179.261 63.2868 180.053 64.4768 181.276 64.7221Z"
            fill="#7383BF"
          />
          <path
            d="M67.0384 48.7112C68.261 48.9565 69.4511 48.1642 69.6964 46.9415C69.9417 45.7188 69.1494 44.5288 67.9267 44.2835C66.7041 44.0382 65.514 44.8305 65.2687 46.0532C65.0234 47.2758 65.8157 48.4659 67.0384 48.7112Z"
            fill="#7383BF"
          />
          <path
            d="M80.3211 51.3761C81.5438 51.6214 82.7338 50.8291 82.9791 49.6065C83.2244 48.3838 82.4321 47.1938 81.2094 46.9485C79.9868 46.7032 78.7967 47.4955 78.5514 48.7182C78.3061 49.9408 79.0984 51.1308 80.3211 51.3761Z"
            fill="#7383BF"
          />
          <path
            d="M173.302 70.0311C174.524 70.2764 175.714 69.4841 175.96 68.2614C176.205 67.0387 175.413 65.8487 174.19 65.6034C172.967 65.3581 171.777 66.1504 171.532 67.3731C171.287 68.5957 172.079 69.7857 173.302 70.0311Z"
            fill="#7383BF"
          />
          <path
            d="M72.347 56.6851C73.5696 56.9305 74.7597 56.1382 75.005 54.9155C75.2503 53.6928 74.458 52.5028 73.2353 52.2575C72.0126 52.0122 70.8226 52.8045 70.5773 54.0272C70.332 55.2498 71.1243 56.4398 72.347 56.6851Z"
            fill="#7383BF"
          />
          <path
            d="M69.6819 69.9681C70.9046 70.2134 72.0946 69.4211 72.3399 68.1984C72.5852 66.9758 71.7929 65.7857 70.5703 65.5404C69.3476 65.2951 68.1576 66.0874 67.9123 67.3101C67.667 68.5328 68.4593 69.7228 69.6819 69.9681Z"
            fill="#7383BF"
          />
          <path
            d="M64.3733 61.9941C65.596 62.2394 66.786 61.4471 67.0313 60.2245C67.2766 59.0018 66.4843 57.8118 65.2617 57.5665C64.039 57.3212 62.849 58.1135 62.6037 59.3361C62.3584 60.5588 63.1507 61.7488 64.3733 61.9941Z"
            fill="#7383BF"
          />
          <path
            d="M77.6561 64.6591C78.8787 64.9044 80.0687 64.1121 80.314 62.8894C80.5594 61.6668 79.767 60.4767 78.5444 60.2314C77.3217 59.9861 76.1317 60.7784 75.8864 62.0011C75.6411 63.2237 76.4334 64.4138 77.6561 64.6591Z"
            fill="#7383BF"
          />
          <path
            d="M165.327 75.3401C166.55 75.5854 167.74 74.7931 167.985 73.5704C168.231 72.3478 167.438 71.1577 166.216 70.9124C164.993 70.6671 163.803 71.4594 163.558 72.6821C163.312 73.9047 164.105 75.0948 165.327 75.3401Z"
            fill="#7383BF"
          />
          <path
            d="M162.662 88.623C163.885 88.8683 165.075 88.076 165.32 86.8533C165.566 85.6307 164.773 84.4407 163.551 84.1954C162.328 83.95 161.138 84.7424 160.893 85.965C160.647 87.1877 161.44 88.3777 162.662 88.623Z"
            fill="#7383BF"
          />
          <path
            d="M170.637 83.314C171.859 83.5593 173.049 82.767 173.295 81.5443C173.54 80.3217 172.748 79.1317 171.525 78.8863C170.302 78.641 169.112 79.4333 168.867 80.656C168.622 81.8787 169.414 83.0687 170.637 83.314Z"
            fill="#7383BF"
          />
          <path
            d="M178.611 78.005C179.833 78.2503 181.023 77.458 181.269 76.2354C181.514 75.0127 180.722 73.8227 179.499 73.5774C178.276 73.3321 177.086 74.1244 176.841 75.347C176.596 76.5697 177.388 77.7597 178.611 78.005Z"
            fill="#7383BF"
          />
          <path
            d="M175.946 91.288C177.168 91.5333 178.358 90.741 178.604 89.5183C178.849 88.2957 178.057 87.1056 176.834 86.8603C175.611 86.615 174.421 87.4073 174.176 88.63C173.931 89.8527 174.723 91.0427 175.946 91.288Z"
            fill="#7383BF"
          />
          <path
            d="M61.7083 75.277C62.931 75.5223 64.121 74.73 64.3663 73.5074C64.6116 72.2847 63.8193 71.0947 62.5966 70.8494C61.374 70.6041 60.184 71.3964 59.9386 72.6191C59.6933 73.8417 60.4856 75.0317 61.7083 75.277Z"
            fill="#7383BF"
          />
          <path
            d="M74.9915 77.942C76.2142 78.1873 77.4042 77.395 77.6495 76.1723C77.8948 74.9497 77.1025 73.7597 75.8798 73.5144C74.6572 73.269 73.4672 74.0614 73.2219 75.284C72.9765 76.5067 73.7688 77.6967 74.9915 77.942Z"
            fill="#7383BF"
          />
          <path
            d="M154.689 93.932C155.911 94.1773 157.101 93.385 157.347 92.1623C157.592 90.9396 156.8 89.7496 155.577 89.5043C154.354 89.259 153.164 90.0513 152.919 91.274C152.674 92.4966 153.466 93.6867 154.689 93.932Z"
            fill="#7383BF"
          />
          <path
            d="M167.972 96.5969C169.195 96.8422 170.385 96.0499 170.63 94.8273C170.875 93.6046 170.083 92.4146 168.86 92.1693C167.638 91.924 166.448 92.7163 166.202 93.939C165.957 95.1616 166.749 96.3516 167.972 96.5969Z"
            fill="#7383BF"
          />
          <path
            d="M67.0174 83.251C68.24 83.4963 69.4301 82.704 69.6754 81.4814C69.9207 80.2587 69.1284 79.0687 67.9057 78.8234C66.6831 78.5781 65.493 79.3704 65.2477 80.593C65.0024 81.8157 65.7947 83.0057 67.0174 83.251Z"
            fill="#7383BF"
          />
          <path
            d="M64.3524 96.5339C65.575 96.7793 66.765 95.987 67.0103 94.7643C67.2556 93.5416 66.4633 92.3516 65.2407 92.1063C64.018 91.861 62.828 92.6533 62.5827 93.876C62.3374 95.0986 63.1297 96.2886 64.3524 96.5339Z"
            fill="#7383BF"
          />
          <path
            d="M59.0433 88.56C60.2659 88.8053 61.4559 88.013 61.7013 86.7903C61.9466 85.5677 61.1543 84.3776 59.9316 84.1323C58.7089 83.887 57.5189 84.6793 57.2736 85.902C57.0283 87.1247 57.8206 88.3147 59.0433 88.56Z"
            fill="#7383BF"
          />
          <path
            d="M72.326 91.225C73.5486 91.4703 74.7387 90.678 74.984 89.4553C75.2293 88.2327 74.437 87.0427 73.2143 86.7974C71.9917 86.5521 70.8016 87.3444 70.5563 88.567C70.311 89.7897 71.1033 90.9797 72.326 91.225Z"
            fill="#7383BF"
          />
          <path
            d="M80.3001 85.916C81.5228 86.1613 82.7128 85.369 82.9581 84.1463C83.2034 82.9237 82.4111 81.7337 81.1884 81.4884C79.9658 81.243 78.7758 82.0354 78.5304 83.258C78.2851 84.4807 79.0774 85.6707 80.3001 85.916Z"
            fill="#7383BF"
          />
          <path
            d="M77.6351 99.1989C78.8577 99.4442 80.0477 98.6519 80.2931 97.4293C80.5384 96.2066 79.7461 95.0166 78.5234 94.7713C77.3007 94.526 76.1107 95.3183 75.8654 96.5409C75.6201 97.7636 76.4124 98.9536 77.6351 99.1989Z"
            fill="#7383BF"
          />
          <path
            d="M152.024 107.215C153.246 107.46 154.436 106.668 154.682 105.445C154.927 104.223 154.135 103.033 152.912 102.787C151.689 102.542 150.499 103.334 150.254 104.557C150.009 105.78 150.801 106.97 152.024 107.215Z"
            fill="#7383BF"
          />
          <path
            d="M159.998 101.906C161.221 102.151 162.411 101.359 162.656 100.136C162.901 98.9136 162.109 97.7236 160.886 97.4783C159.664 97.233 158.474 98.0253 158.228 99.2479C157.983 100.471 158.775 101.661 159.998 101.906Z"
            fill="#7383BF"
          />
          <path
            d="M157.333 115.189C158.555 115.434 159.746 114.642 159.991 113.419C160.236 112.197 159.444 111.007 158.221 110.761C156.998 110.516 155.808 111.308 155.563 112.531C155.318 113.754 156.11 114.944 157.333 115.189Z"
            fill="#7383BF"
          />
          <path
            d="M165.307 109.88C166.53 110.125 167.72 109.333 167.965 108.11C168.21 106.888 167.418 105.698 166.195 105.452C164.973 105.207 163.783 105.999 163.537 107.222C163.292 108.445 164.084 109.635 165.307 109.88Z"
            fill="#7383BF"
          />
          <path
            d="M173.281 104.571C174.503 104.816 175.693 104.024 175.939 102.801C176.184 101.579 175.392 100.389 174.169 100.143C172.946 99.898 171.756 100.69 171.511 101.913C171.266 103.136 172.058 104.326 173.281 104.571Z"
            fill="#7383BF"
          />
          <path
            d="M170.616 117.854C171.838 118.099 173.028 117.307 173.274 116.084C173.519 114.862 172.727 113.672 171.504 113.426C170.281 113.181 169.091 113.973 168.846 115.196C168.601 116.419 169.393 117.609 170.616 117.854Z"
            fill="#7383BF"
          />
          <path
            d="M56.3782 101.843C57.6009 102.088 58.7909 101.296 59.0362 100.073C59.2815 98.8506 58.4892 97.6606 57.2666 97.4153C56.0439 97.17 54.8539 97.9623 54.6086 99.1849C54.3633 100.408 55.1556 101.598 56.3782 101.843Z"
            fill="#7383BF"
          />
          <path
            d="M69.6609 104.508C70.8836 104.753 72.0736 103.961 72.3189 102.738C72.5642 101.516 71.7719 100.326 70.5493 100.08C69.3266 99.835 68.1366 100.627 67.8913 101.85C67.646 103.073 68.4383 104.263 69.6609 104.508Z"
            fill="#7383BF"
          />
          <path
            d="M82.9441 107.173C84.1668 107.418 85.3568 106.626 85.6021 105.403C85.8474 104.181 85.0551 102.991 83.8325 102.745C82.6098 102.5 81.4198 103.292 81.1745 104.515C80.9292 105.738 81.7215 106.928 82.9441 107.173Z"
            fill="#7383BF"
          />
          <path
            d="M109.51 112.503C110.732 112.748 111.922 111.956 112.168 110.733C112.413 109.511 111.621 108.321 110.398 108.075C109.175 107.83 107.985 108.622 107.74 109.845C107.495 111.068 108.287 112.258 109.51 112.503Z"
            fill="#7383BF"
          />
          <path
            d="M149.359 120.498C150.581 120.743 151.771 119.951 152.017 118.728C152.262 117.505 151.47 116.315 150.247 116.07C149.024 115.825 147.834 116.617 147.589 117.84C147.344 119.062 148.136 120.253 149.359 120.498Z"
            fill="#7383BF"
          />
          <path
            d="M162.641 123.163C163.864 123.408 165.054 122.616 165.299 121.393C165.545 120.17 164.752 118.98 163.53 118.735C162.307 118.49 161.117 119.282 160.872 120.505C160.626 121.727 161.419 122.917 162.641 123.163Z"
            fill="#7383BF"
          />
          <path
            d="M61.6868 109.817C62.9095 110.062 64.0995 109.27 64.3448 108.047C64.5901 106.825 63.7978 105.635 62.5752 105.389C61.3525 105.144 60.1625 105.936 59.9172 107.159C59.6719 108.382 60.4642 109.572 61.6868 109.817Z"
            fill="#7383BF"
          />
          <path
            d="M53.7132 115.126C54.9359 115.371 56.1259 114.579 56.3712 113.356C56.6165 112.134 55.8242 110.944 54.6015 110.698C53.3789 110.453 52.1888 111.245 51.9435 112.468C51.6982 113.691 52.4905 114.881 53.7132 115.126Z"
            fill="#7383BF"
          />
          <path
            d="M66.9964 117.791C68.2191 118.036 69.4091 117.244 69.6544 116.021C69.8997 114.799 69.1074 113.609 67.8847 113.363C66.6621 113.118 65.472 113.91 65.2267 115.133C64.9814 116.356 65.7737 117.546 66.9964 117.791Z"
            fill="#7383BF"
          />
          <path
            d="M74.97 112.482C76.1927 112.727 77.3827 111.935 77.628 110.712C77.8733 109.49 77.081 108.3 75.8584 108.054C74.6357 107.809 73.4457 108.601 73.2004 109.824C72.9551 111.047 73.7474 112.237 74.97 112.482Z"
            fill="#7383BF"
          />
          <path
            d="M88.2527 115.147C89.4754 115.392 90.6654 114.6 90.9107 113.377C91.156 112.155 90.3637 110.965 89.1411 110.719C87.9184 110.474 86.7284 111.266 86.4831 112.489C86.2378 113.712 87.0301 114.902 88.2527 115.147Z"
            fill="#7383BF"
          />
          <path
            d="M80.2791 120.456C81.5018 120.701 82.6918 119.909 82.9371 118.686C83.1824 117.464 82.3901 116.274 81.1674 116.028C79.9448 115.783 78.7548 116.575 78.5094 117.798C78.2641 119.021 79.0564 120.211 80.2791 120.456Z"
            fill="#7383BF"
          />
          <path
            d="M93.5623 123.121C94.785 123.366 95.975 122.574 96.2203 121.351C96.4656 120.128 95.6733 118.938 94.4506 118.693C93.228 118.448 92.038 119.24 91.7927 120.463C91.5473 121.685 92.3397 122.876 93.5623 123.121Z"
            fill="#7383BF"
          />
          <path
            d="M101.536 117.812C102.759 118.057 103.949 117.265 104.194 116.042C104.44 114.82 103.647 113.63 102.425 113.384C101.202 113.139 100.012 113.931 99.7668 115.154C99.5215 116.377 100.314 117.567 101.536 117.812Z"
            fill="#7383BF"
          />
          <path
            d="M114.819 120.477C116.042 120.722 117.232 119.93 117.477 118.707C117.722 117.485 116.93 116.294 115.707 116.049C114.485 115.804 113.295 116.596 113.049 117.819C112.804 119.042 113.596 120.232 114.819 120.477Z"
            fill="#7383BF"
          />
          <path
            d="M106.845 125.786C108.068 126.031 109.258 125.239 109.503 124.016C109.748 122.793 108.956 121.603 107.733 121.358C106.511 121.113 105.321 121.905 105.075 123.128C104.83 124.35 105.622 125.54 106.845 125.786Z"
            fill="#7383BF"
          />
          <path
            d="M120.128 128.451C121.351 128.696 122.541 127.904 122.786 126.681C123.032 125.458 122.239 124.268 121.017 124.023C119.794 123.778 118.604 124.57 118.359 125.793C118.113 127.015 118.906 128.206 120.128 128.451Z"
            fill="#7383BF"
          />
          <path
            d="M128.102 123.142C129.325 123.387 130.515 122.595 130.76 121.372C131.005 120.149 130.213 118.959 128.99 118.714C127.768 118.469 126.578 119.261 126.332 120.484C126.087 121.706 126.879 122.896 128.102 123.142Z"
            fill="#7383BF"
          />
          <path
            d="M141.385 125.807C142.608 126.052 143.798 125.26 144.043 124.037C144.288 122.815 143.496 121.625 142.273 121.379C141.051 121.134 139.861 121.926 139.615 123.149C139.37 124.372 140.162 125.562 141.385 125.807Z"
            fill="#7383BF"
          />
          <path
            d="M133.411 131.116C134.634 131.361 135.824 130.569 136.069 129.346C136.314 128.123 135.522 126.933 134.299 126.688C133.077 126.443 131.887 127.235 131.641 128.458C131.396 129.68 132.188 130.87 133.411 131.116Z"
            fill="#7383BF"
          />
          <path
            d="M146.694 133.781C147.917 134.026 149.107 133.234 149.352 132.011C149.597 130.788 148.805 129.598 147.582 129.353C146.36 129.108 145.17 129.9 144.924 131.123C144.679 132.345 145.471 133.535 146.694 133.781Z"
            fill="#7383BF"
          />
          <path
            d="M154.668 128.472C155.89 128.717 157.08 127.925 157.326 126.702C157.571 125.479 156.779 124.289 155.556 124.044C154.333 123.799 153.143 124.591 152.898 125.814C152.653 127.036 153.445 128.227 154.668 128.472Z"
            fill="#7383BF"
          />
          <path
            d="M159.977 136.446C161.2 136.691 162.39 135.899 162.635 134.676C162.88 133.453 162.088 132.263 160.865 132.018C159.643 131.773 158.453 132.565 158.207 133.788C157.962 135.01 158.754 136.2 159.977 136.446Z"
            fill="#7383BF"
          />
          <path
            d="M167.951 131.137C169.174 131.382 170.364 130.59 170.609 129.367C170.854 128.144 170.062 126.954 168.839 126.709C167.617 126.464 166.427 127.256 166.181 128.479C165.936 129.701 166.728 130.891 167.951 131.137Z"
            fill="#7383BF"
          />
        </g>
        <g>
          <path
            d="M56.0616 57.2102L6.62158 72.0214L19.029 113.438L68.469 98.6265L56.0616 57.2102Z"
            fill="#F6C358"
          />
          <path
            d="M53.6588 49.1891L4.21875 64.0003L16.6262 105.417L66.0662 90.6054L53.6588 49.1891Z"
            fill="#FCD462"
          />
          <path
            d="M55.273 93.8413L62.8331 79.8143L52.0396 83.0479L55.273 93.8413Z"
            fill="#F6C358"
          />
        </g>
        <g>
          <path
            d="M37.4719 158.022L100.136 157.23L99.1377 78.2187L50.0963 78.8383L36.6457 92.633L37.4719 158.022Z"
            fill="#E9E9E0"
          />
          <path
            d="M50.2684 92.4609L50.0963 78.8383L36.6457 92.633L50.2684 92.4609Z"
            fill="#D9D7CA"
          />
          <path
            d="M74.641 137.856L72.4773 124.88L73.8395 124.863L73.7363 116.689L62.8382 116.827L62.9414 125L64.3037 124.983L62.4685 138.01C62.3018 139.191 62.6602 140.386 63.4485 141.282C64.2375 142.177 65.3775 142.683 66.5708 142.667L70.6576 142.615C71.8509 142.601 72.9778 142.067 73.744 141.152C74.5094 140.237 74.8375 139.033 74.641 137.856Z"
            fill="#DEDEDE"
          />
          <path
            d="M73.3406 85.3569L73.3062 82.6324L69.2194 82.684L69.1678 78.5972L66.4432 78.6317L66.4949 82.7185L62.4081 82.7701L62.4425 85.4946L66.5293 85.443L66.5637 88.1675L62.4769 88.2191L62.5113 90.9437L66.5981 90.892L66.6326 93.6165L62.5458 93.6682L62.5802 96.3927L66.667 96.3411L66.7014 99.0656L62.6146 99.1172L62.649 101.842L66.7358 101.79L66.7703 104.515L62.6835 104.566L62.7179 107.291L66.8047 107.239L66.8391 109.964L62.7523 110.015L62.7867 112.74L66.8735 112.688L66.9768 120.862L69.7013 120.827L69.598 112.654L73.6848 112.602L73.6504 109.878L69.5636 109.929L69.5292 107.205L73.616 107.153L73.5816 104.429L69.4948 104.48L69.4604 101.756L73.5471 101.704L73.5127 98.9795L69.4259 99.0312L69.3915 96.3066L73.4783 96.255L73.4439 93.5305L69.3571 93.5821L69.3227 90.8576L73.4094 90.806L73.375 88.0814L69.2882 88.1331L69.2538 85.4086L73.3406 85.3569Z"
            fill="#A2A9AD"
          />
          <path
            d="M67.1665 135.847L69.891 135.812L69.9255 138.537L67.2009 138.571L67.1665 135.847Z"
            fill="#C7C7C7"
          />
          <path
            d="M66.9253 116.775L69.6498 116.741L69.7015 120.827L66.9769 120.862L66.9253 116.775Z"
            fill="#A2A9AD"
          />
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="37.312"
            y="0"
            width="164.814"
            height="154.196"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d"
            x="0.21875"
            y="49.1891"
            width="72.2503"
            height="72.2486"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d"
            x="32.4736"
            y="78.2187"
            width="71.6623"
            height="87.8029"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default RightIcon;
